import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import KioskLoginFormContainer from './KioskLoginFormContainer';

class KioskLoginFormModal extends React.Component {
  render() {
    return (
      <Modal
        paddingTop="65px"
        overlayTop={0}
        closeOnOverlayClick
        closeOnOutsideClick={false}
        isOpened
        onClose={() => {}}
      >
        <KioskLoginFormContainer/>
      </Modal>
    );
  }

}

KioskLoginFormModal.propTypes = {};

export default KioskLoginFormModal;



// WEBPACK FOOTER //
// ./src/components/KioskLoginForm/KioskLoginFormModal.jsx